// 引入Axios实例
import axios from "./ajax";
// 引入ElementUi库 通知组件
import { Message } from "ant-design-vue"

// 申明全局ws实例
if (!window.wsClient) window.wsClient = {}

/*
  websocket使用封装
  @name websocket名称，默认大写英文，必填
  @api  websocket连接地址，必填，如：/system/admin/websocket/80:{tid}:{uid}
  @callFuc  websocket通信回调函数，选填
 */

export default (name, api, callFuc, callFuc2)=>{
  // 使用websocket实时更新数据
  // const wsApi = (location.href.includes('https://')?"wss://":"ws://") + axios.defaults.baseURL.split("//")[1] + api
  // 兼容配置文件中AXIOS的BASEURL为全地址和前端代理的配置
  const wsApi = (location.href.includes('https://')?"wss://":"ws://") + (['http:', 'https:'].includes(axios.defaults.baseURL.split("//")[0])?axios.defaults.baseURL.split("//")[1]:(location.host + axios.defaults.baseURL)) + api
  window.wsClient[name] = null

  // 判断浏览器是否支持websocket
  if (!window.WebSocket) {
    setTimeout(() => {
      Message.warning('您的浏览器不支持Websocket，请升级浏览器！')
    }, 100);
    return
  }

  // 连接websocket服务
  try {
    window.wsClient[name] = new WebSocket(wsApi);
  } catch (error) {
    setTimeout(() => {
      Message.error('请检查当前Websocket地址是否被支持！')
    }, 100);
    // console.log(error);
  }

  // 判断ws服务是否链接
  if (!window.wsClient[name]) {
    return
  }

  // 监听连接成功，发送心跳
  window.wsClient[name].onopen = () => {
    console.info(name+'_WS 连接成功!')
    window.wsClient[name].send("ping")
    // console.info(name+"_WS 发送消息：ping")
    window.wsClient[name].timer = setInterval(() => {
      window.wsClient[name].send("ping")
      // console.info(name+"_WS 发送消息：ping")
    }, 30000);
  };

  // 监听连接关闭
  window.wsClient[name].onclose = (e) => {
    console.warn(name+'_WS 连接关闭!' + e.code +"-"+ e.reason +"-"+ e.wasClean);
    clearInterval(window.wsClient[name].timer)
  };

  // 监听接收消息
  window.wsClient[name].onmessage = (msg) => {
    // console.log(msg)
    if (msg.data!='pong') {   // 排除心跳消息

      console.info(name+'_WS 接收消息：'+msg.data);

      const wsMsg = JSON.parse(msg.data);


      switch (wsMsg.type){
        case 'jobState':
          callFuc(wsMsg.type, wsMsg.body)
          break
        case 'robotState':
          callFuc(wsMsg.type, wsMsg.body)
          break
        case 'updateVersion':
          callFuc(wsMsg.type, wsMsg.body)
          break
      }
    }
  };

  // 监听连接异常
  window.wsClient[name].onerror = () => {
    console.warn(name+'_WS 连接异常!');
  };
}